function tagBlockInit() {

  var ele   = $('.blog-block-multiple_tags');

  if(ele.length > 0) {
    ele.find('.tag-group:first').addClass('open');
  }

}

function tagBlockSwitch(target) {

  target.closest('.expandable-group').find('.open').removeClass('open');
  target.closest('.tag-group').addClass('open');

}

$('.blog-block-multiple_tags .expandable-initial').click( function() {
  tagBlockSwitch($(this));
});

tagBlockInit();
